import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { style: {"text-align":"center"} }, "Select a Protocol to Manage:", -1)

import { Protocol } from "@/models/Protocol";
import ProtocolSelector from "@/components/ProtocolSelector.vue";
import { ref } from "vue";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const router = useRouter();

const selectedProtocol = ref<Protocol>();
const selectProtocol = (aProtocol: Protocol): void => {
  selectedProtocol.value = aProtocol;
  router.push(`/manager/${aProtocol.id}`);
};
const id = "select";
// eslint-disable-next-line no-undef
expose({ id });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(ProtocolSelector, {
      showSearch: false,
      showUserInfo: false,
      manager: true,
      autoSelect: true,
      onSelection: selectProtocol
    })
  ]))
}
}

})